<template>
  <el-container style="background: #f5f7f8">
    <!-- <el-header>
      <div v-if="isMenu">
        <img src="@/assets/images/console-logo.png" class="middle" v-if="$store.state.app.device == 'desktop'">
        <img src="@/assets/images/logo.png" class="middle" v-if="$store.state.app.device == 'desktop'">

        <i class="el-icon-s-fold middle pointer" @click="isMenu = false" ></i>
        <span class="text">工作台</span>
      </div>
      <div v-else>
        <i class="el-icon-s-unfold middle" @click="isMenu = true"></i>
        <span class="text">工作台</span>
      </div>

      <div class="pointer">
        <i class="el-icon-arrow-left middle" @click="$router.push({ path: '/' })"></i>
        <span class="text" @click="$router.push({ path: '/' })">返回平台首页</span>
        <span class="text">{{ username }}</span>
      </div>

    </el-header> -->
    <el-header class="consoleheader">
      <div>
        <img
          src="@/assets/images/consolelog.png"
          class="middle"
          v-if="$store.state.app.device == 'desktop'"
        />
        <el-tag color="#e3ecff" style="color: #409eff; border-color: #409eff"
          ><i class="el-icon-s-platform icon"></i>工作台
        </el-tag>
        <p class="turnbutton ml50">
          <span
            @click="
              () => {
                // $router.push('/ProductService')
                // window.open('https://eiiplat.com/ProductService')
                openNew(1);
              }
            "
            >产品服务</span
          >
          <span
            @click="
              () => {
                // $router.push('/Solution')
                openNew(2);
                // window.open('https://eiiplat.com/Solution')
              }
            "
            >解决方案</span
          >
        </p>
      </div>
      <div style="display: flex">
        <!-- <el-input placeholder="请输入内容" style="width: 200px;">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input> -->
        <div
          style="
            width: 365px;
            line-height: 40px;
            display: flex;
            align-items: center;
            gap: 17px;
          "
        >
          <!--
          <el-dropdown trigger="click" placement="bottom">
            <span class="el-dropdown-link">
              应用<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu size="small" slot="dropdown">
              <el-dropdown-item>应用上架</el-dropdown-item>
              <el-dropdown-item>应用购买</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown trigger="click" placement="bottom" style="margin-left: 16px;">
            <span class="el-dropdown-link">
              支持<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu size="small" slot="dropdown">
              <el-dropdown-item>共推共建</el-dropdown-item>
              <el-dropdown-item>帮助文档</el-dropdown-item>
              <el-dropdown-item>建议反馈</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <p class="turnbutton">
            <span @click="openArchives">企业档案</span>
          </p>

          <!-- <p class="turnbutton">
            <span @click="openNewwindow">应用</span>
          </p> -->

          <p class="turnbutton">
            <span
              @click="
                () => {
                  $router.push('/');
                }
              "
              >平台首页</span
            >
          </p>
          <el-dropdown>
            <div
              style="margin-top: 15px; margin-right: 20px"
              @click="goMessage"
            >
              <el-badge :value="badgeVal" class="item" :max="99">
                <i class="el-icon-bell" style="font-size: 24px"></i>
              </el-badge>
            </div>
            <el-dropdown-menu trigger="click" slot="dropdown">
              <div class="drop_title">站内消息通知</div>
              <el-dropdown-item
                divided
                command="info"
                v-for="(item, index) in messageList"
                :key="index"
                ><div>
                  {{ item.notice_title }}
                  <div>{{ item.send_time }}</div>
                </div></el-dropdown-item
              >
              <div class="lookMore" @click="moreMsg">查看更多</div>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="handleCommand">
            <span style="color: #000; cursor: pointer">
              <!-- <i class="el-icon-user-solid" style="font-size: 14px"></i> -->
              <img
                style="width: 40px; height: 40px"
                src="../assets/images/console/userimg.png"
                alt=""
              />
            </span>
            <el-dropdown-menu trigger="click" slot="dropdown">
              <el-dropdown-item command="info" icon="el-icon-user"
                >个人信息</el-dropdown-item
              >
              <el-dropdown-item
                command="resetPhone"
                icon="el-icon-document-checked"
                >修改绑定手机</el-dropdown-item
              >
              <el-dropdown-item command="reset" icon="el-icon-lock"
                >修改密码</el-dropdown-item
              >
              <el-dropdown-item command="logout" icon="el-icon-switch-button"
                >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-header>
    <el-container>
      <!-- <el-aside v-if="isMenu && $store.state.app.device == 'desktop'" width="200px">
        <el-menu default-active="0" @select="handleMenuClick">
          <el-menu-item v-for="(item, index) in menu" :key="index" :index="`${index}`">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </el-menu>
      </el-aside> -->
      <!-- <div v-if="$store.state.app.device !== 'desktop'">
        <el-drawer :show-close="false" :modal="false" :visible.sync="isMenu" :withHeader="false" direction="ltr">
          <el-menu default-active="0" @select="handleMenuClick">
            <el-menu-item v-for="( item, index ) in  menu " :key="index" :index="`${index}`">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </el-menu>
        </el-drawer>
      </div> -->

      <transition name="fade-transform" mode="out-in">
        <el-main>
          <router-view :key="key" />
        </el-main>
      </transition>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { getveriftToken } from "@/api/console";
import { sendMsg, getMsgRead, getMsgList } from "@/api/message";
// import WebSocket from 'ws';
var socket = null;
export default {
  name: "Layout",
  data() {
    return {
      isMenu: true,
      menu: [
        { name: "工作台", icon: "el-icon-s-home", path: "/console/index" },
        {
          name: "修改密码",
          icon: "el-icon-user-solid",
          path: "/console/password",
        },
      ],
      messageList: [],
      socket: null,
    };
  },
  watch: {
    userName(newVal) {
      if (newVal) this.getProProduct();
    },
  },
  computed: {
    key() {
      return this.$route.path;
    },
    username() {
      return this.$store.state.user.userName;
    },
    badgeVal() {
      return this.$store.state.user.badgeVal;
    },
    ...mapGetters(["userName"]),
  },
  mounted() {
    this.initWebSocket();
    this.getMsgListInfo();
    this.getMsgTotal();
  },
  created() {
    // this.getPartnerList()
    if (this.userName) {
      this.getToken();

      // localStorage.setItem("userName", "");
      // localStorage.setItem("usertoken", "");
      // localStorage.setItem("userId", "");
      // localStorage.setItem("phonenumber", "");
    }
    // if (this.userName) this.getProProduct()
  },
  methods: {
    ...mapMutations([
      "SET_BADGEVAL", //将mutation里的方法映射到该组件内
      //等同于this.$store.commit('SET_BADGEVAL')
    ]),
    getMsgListInfo() {
      let params = {
        pageSize: 5,
        pageNum: 1,
        readFlag: "0",
      };
      getMsgList(params).then((res) => {
        this.messageList = res.rows;
        this.total = res.total;
      });
    },
    getMsgTotal() {
      this.$store.dispatch("getbadgeVal");
    },
    sendMsg() {
      let data = {
        noticeType: "1",
        noticeTitle: "晨会内容提要",
        msgType: "1",
      };
      let id = 1;
      sendMsg(data, id).then((res) => {
        console.log(res, "fasonglema");
      });
    },
    goMessage() {
      // this.sendMsg()
      this.$router.push("/Message/index");
    },
    generateRandomString() {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      const len = chars.length;
      let result = "";
      for (let i = 0; i < 32; i++) {
        result += chars.charAt(Math.floor(Math.random() * len));
      }
      return result;
    },
    initWebSocket() {
      let that = this;
      let randomString = this.generateRandomString();
      let id = localStorage.getItem("userId");
      // socket = new WebSocket(
      // "ws://47.96.70.127:83/ws/system/api/v1/msg/" + id + '-' + randomString
      // );
      // 正式环境打包修改此处
      socket = new WebSocket(
        "wss://www.eiiplat.com/ws2/system/api/v1/msg/" + id + "-" + randomString
      );
      var heartbeatTimer = null;
      socket.addEventListener("open", function (event) {
        heartbeatTimer = setInterval(function () {
          socket.send("heartbeat");
        }, 30000);
      });
      socket.addEventListener("message", function (event) {
        that.getMsgListInfo();
        that.getMsgTotal();
        let data = JSON.parse(event.data);
        //业务处理....
        if (data.step == 1) {
          // alert(data.msg);
        }
      });
      socket.onerror = function () {
        console.log("error");
        // notify.warn("websocket通信发生错误！");
        // initWebSocket()
      };
      window.onbeforeunload = function () {
        this.socket.close();
      };
    },
    handleMenuClick(index) {
      this.$router.push({ path: this.menu[index].path });
    },
    ...mapActions({
      quit: "logout",
    }),
    handleCommand(command) {
      if (command == "console") {
        this.$router.push({ path: "/console" });
      } else if (command == "reset") {
        this.$router.push({ path: "/resetPWD" });
      } else if (command == "info") {
        //个人信息
        this.$router.push({ path: "/userInfo" });
      } else if (command == "resetPhone") {
        //修改绑定手机
        this.$router.push({ path: "/resetPhoneNumber" });
      } else {
        this.quit();
        this.$router.push("/");
      }
    },
    openNewwindow() {
      window.open(
        `http://app.eiiplat.com/#/index?userName=${localStorage.userName}&token=${localStorage.usertoken}`
      );
    },
    openNew(type) {
      window.open(
        type == 1
          ? "https://eiiplat.com/ProductService"
          : "https://eiiplat.com/Solution"
      );
    },
    openArchives() {
      //测试环境
      /* let paramsAuth = {
        appId: 'E3496795456453786218',
        username: localStorage.account,
        password: localStorage.password,
        redirectUri: 'http://47.96.70.127:8865'
      }*/
      //正式环境
      let paramsAuth = {
        appId: "E3496795456453786218",
        username: localStorage.account,
        password: localStorage.password,
        redirectUri: "http://ams.eiiplat.com",
      };
      this.$axios({
        url: "/api/oapi/oauth2/login",
        method: "post",
        data: paramsAuth,
      })
        .then((res) => {
          if (res.data.code === 0) {
            window.open("" + res.data.data.redirectUri);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error("登录错误，请重试！");
          console.log(err);
        });
    },
    //查询当前登录token是否有效
    async getToken() {
      const data = await getveriftToken();
      if (data.msg == 0) {
        localStorage.clear();
      }
    },
    moreMsg() {
      this.$router.push("/Message/index");
    },
  },
};
</script>

<style :lang="less" scoped>
.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background-color: #131415; */
  /* color: #fff;    */
  background: #fff;

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.icon {
  vertical-align: middle;
}

.el-dropdown {
  cursor: pointer;
  font-size: 0.14rem;
}

.el-dropdown > span {
  font-size: 0.14rem !important;
}

.turnbutton {
  display: inline-block;
  margin: 0;
  padding: 0;
  font-size: 1rem;

  & .ml50 {
    margin-left: 50px;
    width: 178px;
  }
}

.turnbutton > span {
  font-size: 14px;
  text-align: center;
  display: inline-block;
  width: 86px;
  color: #333;
  cursor: pointer;
}

.el-header .text {
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  vertical-align: middle;
}

.el-aside {
  min-height: calc(100vh - 60px);
  background-color: #fff;
  color: #333;
  padding-top: 30px;
}

.middle {
  vertical-align: middle;
  /* height: 31px; */
  width: 126px;
  height: 50px;
}

.pointer {
  margin-left: 20px;
  cursor: pointer;
}
.drop_title {
  width: 250px;
  padding: 0 10px;
  box-sizing: border-box;
  height: 20px;
}
.lookMore {
  width: 100%;
  padding: 5px 10px;
  box-sizing: border-box;
  height: 20px;
  cursor: pointer;
  border-top: 1px solid #eaeefb;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue